import { cn } from '@/lib/utils';
import React from 'react';

type HatchetLogoProps = React.SVGAttributes<SVGSVGElement> & {
  title?: string;
  colorVariant?: 'brand' | 'inherit';
  variant?: 'lockup' | 'mark' | 'wordmark';
};

/**
 * Hatchet wordmark + mark, aligned with the marketing site (`hatchet-marketing`).
 * Uses `currentColor` so it automatically adapts to theme via text color.
 */
export function HatchetLogo({
  title = 'Hatchet',
  colorVariant = 'brand',
  variant = 'lockup',
  className,
  ...props
}: HatchetLogoProps) {
  const isMarkOnly = variant === 'mark';
  const isWordmarkOnly = variant === 'wordmark';

  return (
    <svg
      viewBox={
        isMarkOnly ? '0 0 33 24' : isWordmarkOnly ? '41 0 96 24' : '0 0 137 24'
      }
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      className={cn(
        colorVariant === 'brand' &&
          'text-[rgb(0,26,56)] dark:text-[rgb(184,217,255)]',
        className,
      )}
      {...props}
    >
      {!isWordmarkOnly ? (
        <>
          <path
            d="M17.5 10L22 0L30.6059 8.60589C31.7939 9.79394 32.388 10.388 32.6105 11.0729C32.8063 11.6755 32.8063 12.3245 32.6105 12.9271C32.388 13.612 31.7939 14.2061 30.6059 15.3941L22 24H15L26.7517 11.3444C27.146 10.9197 27.3432 10.7074 27.3527 10.5263C27.361 10.3691 27.2947 10.2171 27.1739 10.1162C27.0347 10 26.7449 10 26.1654 10H17.5Z"
            fill="currentColor"
          />
          <path
            d="M16.5 14L12 24L3.39411 15.3941C2.20606 14.2061 1.61204 13.612 1.38947 12.9271C1.1937 12.3245 1.1937 11.6755 1.38947 11.0729C1.61204 10.388 2.20606 9.79394 3.39411 8.60589L12 0H19L7.24833 12.6556C6.854 13.0803 6.65684 13.2926 6.6473 13.4737C6.63902 13.6309 6.70527 13.7829 6.82612 13.8838C6.96529 14 7.25505 14 7.83457 14H16.5Z"
            fill="currentColor"
          />
        </>
      ) : null}

      {!isMarkOnly ? (
        <path
          d="M88.5908 3.14502C92.0637 3.14506 94.5478 5.30746 94.5479 8.96436V10.1147H91.0977V9.05615C91.0975 7.42337 90.0857 6.36577 88.5908 6.36572C87.0959 6.36572 86.0841 7.42333 86.084 9.05615V14.9448C86.0841 16.5776 87.0959 17.6353 88.5908 17.6353C90.0856 17.6352 91.0975 16.5776 91.0977 14.9448V13.6108H94.5479V14.9448C94.5477 18.6476 92.0866 20.8549 88.5908 20.855C85.0949 20.855 82.634 18.6476 82.6338 14.9448V8.96436C82.6338 5.30742 85.1179 3.14502 88.5908 3.14502ZM80.4238 6.61865H76.3994V20.6489H72.9492V6.61865H68.9238V3.39893H80.4238V6.61865ZM136.884 6.61865H132.858V20.6489H129.408V6.61865H125.384V3.39893H136.884V6.61865ZM44.4502 10.3677H49.4414V3.37549H52.8916V20.6255H49.4414V13.5874H44.4502V20.6255H41V3.37549H44.4502V10.3677ZM68.4639 20.6255H64.3926L63.9326 18.3022H59.7461L59.2861 20.6255H55.4688L59.7461 3.37549H64.1855L68.4639 20.6255ZM101.157 10.3677H106.148V3.37549H109.598V20.6255H106.148V13.5874H101.157V20.6255H97.707V3.37549H101.157V10.3677ZM122.801 6.59521H116.361V10.1831H121.812V13.4038H116.361V17.4058H122.848V20.6255H112.911V3.37549H122.801V6.59521ZM60.2988 15.5425H63.4033L61.8623 7.72217L60.2988 15.5425Z"
          fill="currentColor"
        />
      ) : null}
    </svg>
  );
}
